import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class File extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    classes: PropTypes.string,
    isRequired: PropTypes.bool,
    fileValidate: PropTypes.bool,
    value: PropTypes.node,
  };

  static defaultProps = {
    name: '',
    classes: '',
    isRequired: true,
    fileValidate: false,
    value: '',
  };

  state = {
    errorMessage: null,
  };

  imageIsValid = (icon) => {
    if (icon.size <= 1500) {
      return true;
    } else {
      return false;
    }
  }

  onChange = (e) => {
    const {
      onChange,
      fileValidate,
    } = this.props;

    if (fileValidate) {
      let iconFile = e.target.files[0];

      if (this.imageIsValid(iconFile)) {
        onChange(e);
        const errorMessage = "";
        this.setState({ errorMessage });
      } else {
        e.target.value = null;
        const errorMessage = "The file may not be greater than 1000 kilobytes";
        this.setState({ errorMessage });
      }
    } else {
      onChange(e);
    }
  }

  validate = (value = this.props.value) => {
    const realValue = !!value.name ? value.name : value; 
    const isValid = this.props.isRequired ? !!realValue : true;
    const errorMessage = !isValid ? 'This field is required' : null;
    this.setState({ errorMessage });
    return isValid;
  };

  render() {
    const {
      name,
      classes,
    } = this.props;

    const {
      errorMessage,
    } = this.state;

    return (
      <div>
        <input
          type="file"
          name={name}
          onChange={this.onChange}
          className={classes}
        />
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
    );
  }
}

export default File;


// WEBPACK FOOTER //
// ./src/app/components/baseComponents/file.js